import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { useState } from 'react';
import { Button } from '~/components/buttons/Button/Button';

// [MCV-1889] DD25: cancelling a hand-filled listing. The buttons never read "Cancel" twice, and the
// owner can copy the listing to a new draft in the same step.
export const CancelListingDialog = ({
  listingTitle,
  open,
  onClose,
  onConfirm,
}: {
  listingTitle: string | undefined;
  open: boolean;
  onClose: () => void;
  onConfirm: (relist: boolean) => void;
}) => {
  const [relist, setRelist] = useState(false);
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-grey-100/60 backdrop-blur-sm" />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <DialogPanel className="w-full max-w-md rounded-xl bg-white p-6 text-left shadow-xl">
            <DialogTitle
              data-cy="cancel-listing-title"
              className="text-lg font-semibold text-grey-100"
            >
              Cancel this listing?
            </DialogTitle>
            <p className="mt-2 text-sm text-grey-400">
              {listingTitle ? `"${listingTitle}" is marked as filled. ` : ''}
              Cancelling it closes it for good. You can copy it to a new draft instead of starting
              over.
            </p>
            <label className="mt-4 flex items-center gap-2 text-sm text-grey-200">
              <input
                type="checkbox"
                data-cy="cancel-listing-relist"
                checked={relist}
                onChange={(event) => setRelist(event.target.checked)}
              />
              Relist as a new draft
            </label>
            <div className="mt-6 flex justify-end gap-3">
              <Button
                cyTag="cancel-listing-keep"
                type="button"
                colorVariant="secondary"
                onClick={onClose}
              >
                Keep listing
              </Button>
              <Button
                cyTag="cancel-listing-confirm"
                type="button"
                colorVariant="error"
                onClick={() => onConfirm(relist)}
              >
                Cancel listing
              </Button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};
